import React from 'react';
import css from "./SecSeven.module.scss";
import {Link} from "react-router-dom";
import {PORTFOLIO} from "../../../Utils/Urls";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import {useTranslation} from "react-i18next";

const SecSeven = () => {

    const {t} = useTranslation();

    return (
        <section className={css.seven}>
            <Link
                to={PORTFOLIO +"/all"}
            >
                {t("portfolio")} <ArrowOutwardIcon/>
            </Link>
        </section>
    );
};

export default SecSeven;